import ListTesti from './ListTesti';
import LayoutAdmin from '../../components/layouts/LayoutAdmin';
import FormTesti from './FormTesti';

export default function Testimonial() {
  return (
    <LayoutAdmin header="Testimonial">
      <div className="flex sm:flex-row flex-col gap-4 md:justify-between w-full overflow-hidden">
        <FormTesti />
        <ListTesti />
      </div>
    </LayoutAdmin>
  );
}
